import { apiRequest } from './auth';

export const shiftsAPI = {
  getAll: async () => {
    return await apiRequest('/shifts');
  },

  getByProject: async (project) => {
    return await apiRequest(`/shifts/${encodeURIComponent(project)}`);
  },

  add: async (project, shiftData) => {
    // Obsługa zarówno starego formatu (string) jak i nowego (obiekt)
    const body = typeof shiftData === 'string' 
      ? { shiftName: shiftData }
      : { shiftData: shiftData };
    
    return await apiRequest(`/shifts/${encodeURIComponent(project)}`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },

  remove: async (project, shiftName) => {
    return await apiRequest(`/shifts/${encodeURIComponent(project)}/${encodeURIComponent(shiftName)}`, {
      method: 'DELETE',
    });
  }
};

export default shiftsAPI;
